import { Capacitor } from '@capacitor/core'
import { createAnimation, iosTransitionAnimation, mdTransitionAnimation } from '@ionic/react'

// const iosAnimation = (baseEl: any, opts: any) => {
//   const enteringAnimation = createAnimation()
//     .addElement(opts.enteringEl)
//     .fromTo('transform', 'translateX(100%)', 'translateX(0%)')
//     .fromTo('opacity', 0, 1)
//     .duration(250)

//   const leavingAnimation = createAnimation()
//     .addElement(opts.leavingEl)
//     .fromTo('transform', 'translateX(0%)', 'translateX(-100%)')
//     .fromTo('opacity', 1, 0)
//     .duration(250)

//   const animation = createAnimation().addAnimation(enteringAnimation).addAnimation(leavingAnimation)

//   return animation
// }

// const androidAnimation = (baseEl: any, opts: any) => {
//   const enteringAnimation = createAnimation()
//     .addElement(opts.enteringEl)
//     .fromTo('transform', 'translateX(100%)', 'translateX(0%)')
//     .fromTo('opacity', 0, 1)
//     .duration(250)

//   const leavingAnimation = createAnimation()
//     .addElement(opts.leavingEl)
//     .fromTo('transform', 'translateX(0%)', 'translateX(-100%)')
//     // .fromTo('opacity', 1, 0)
//     .duration(250)

//   const animation = createAnimation().addAnimation([enteringAnimation, leavingAnimation])

//   return animation
// }

export const webAnimation = (baseEl: any, opts: any) => {
  const enteringAnimation = createAnimation('page-enter').addElement(opts.enteringEl).fromTo('opacity', 0, 1).duration(200)

  const leavingAnimation = createAnimation('page-exit').addElement(opts.leavingEl).fromTo('opacity', 1, 0).duration(200)

  const animation = createAnimation('page-transitions').addAnimation(enteringAnimation).addAnimation(leavingAnimation)

  return animation
}

export const pageAnimationBuilder = (baseEl: any, opts: any) => {
  const platform = Capacitor.getPlatform()

  switch (platform) {
    case 'ios':
      return iosTransitionAnimation(baseEl, opts)

    case 'android':
      return mdTransitionAnimation(baseEl, opts)

    default:
      return webAnimation(baseEl, opts)
  }
}
